export const isMobile = () => {
  return !!window.matchMedia("(max-width: 900px)").matches;
};
